import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type {
  RawPlantsResponse,
  RawPlantsRequest,
  RawPlantResponse,
  RawProfileResponse,
  RawUpdateProfileRequest,
} from '../types/plant';
import type { RequestOptions } from '../types/common';

export function createPlantApi(http: Http) {
  return {
    async list(include?: string, options?: RequestOptions): Promise<RawPlantsResponse> {
      const res = await http.get<RawPlantsResponse>(endpoints.plant.base, {
        params: include !== undefined ? { include } : undefined,
        signal: options?.signal,
      });
      return res.data;
    },

    async update(data?: RawPlantsRequest): Promise<RawPlantsResponse> {
      const res = await http.put<RawPlantsResponse>(endpoints.plant.base, data);
      return res.data;
    },

    async detail(plantId: number, options?: RequestOptions): Promise<RawPlantResponse> {
      const res = await http.get<RawPlantResponse>(endpoints.plant.byId(plantId), {
        signal: options?.signal,
      });
      return res.data;
    },

    async getProfile(
      plantId: number,
      options?: RequestOptions,
    ): Promise<RawProfileResponse | null> {
      const res = await http.get<RawProfileResponse | null>(endpoints.plant.profile(plantId), {
        signal: options?.signal,
      });
      return res.data;
    },

    async updateProfile(
      plantId: number,
      data: RawUpdateProfileRequest,
    ): Promise<RawProfileResponse> {
      const res = await http.put<RawProfileResponse>(endpoints.plant.profile(plantId), data);
      return res.data;
    },
  };
}
